import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import AttachFileIcon from '@mui/icons-material/AttachFile';

const fileTypes = ["JPG", "JPEG", "PNG", "HEIC", "HEIF", "PDF"];

class DragDrop extends React.Component {

  render() {
    return (
      <FileUploader
        name="file" 
        types={fileTypes} 
        hoverTitle={(<div/>)}
        onTypeError={() => alert('png, jpg, heic, or pdf only please')}
        children={(
          <div className="dropzone-container">
            <AttachFileIcon className="image-upload-drop-icon" />
            <p>Drop a file here to attach</p>
            <span>or click to browse</span>
          </div>
        )}
        onDrop={file => this.props.upload(file)}
        onSelect={file => this.props.upload(file)}
      />
    );
  }
}

export default DragDrop;